import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { TrendingUp, Zap, ShieldCheck } from "lucide-react";

const Rates = () => {
  const [rates, setRates] = useState([]);
  const [updated, setUpdated] = useState("");
  const [source, setSource] = useState("");
  useEffect(() => {
    api.get("/fx/rates").then(r => {
      setRates(r.data.rates);
      setUpdated(r.data.updated_at);
      setSource(r.data.source);
    });
  }, []);

  return (
    <div className="max-w-5xl mx-auto px-5 sm:px-8 py-12" data-testid="rates-root">
      <div className="mb-8 fade-up">
        <div className="flex items-center gap-2 mb-2">
          <span className="text-xs uppercase tracking-[0.2em] text-[var(--ra-accent)] font-semibold">Live FX</span>
          {source === "live" && (
            <span className="inline-flex items-center gap-1 text-[10px] uppercase tracking-wide font-semibold text-emerald-700 bg-emerald-100 px-2 py-0.5 rounded-full" data-testid="rates-live-badge">
              <span className="w-1.5 h-1.5 rounded-full bg-emerald-500 animate-pulse" /> Live
            </span>
          )}
        </div>
        <h1 className="font-heading text-4xl font-bold tracking-tight">Rates &amp; Fees</h1>
        <p className="text-[var(--ra-muted)] mt-2" data-testid="rates-updated">
          Live rates, updated {updated ? new Date(updated).toLocaleString() : "just now"}. Base: 1 USD.
        </p>
      </div>

      <div className="ra-card overflow-hidden p-0 fade-up fade-up-2">
        <table className="w-full text-sm">
          <thead className="bg-[var(--ra-primary)]/5 text-[var(--ra-primary)] uppercase text-xs tracking-wider">
            <tr>
              <th className="text-left px-5 py-3 font-semibold">Country</th>
              <th className="text-left px-5 py-3 font-semibold">Currency</th>
              <th className="text-right px-5 py-3 font-semibold">1 USD =</th>
              <th className="text-right px-5 py-3 font-semibold">100 USD =</th>
            </tr>
          </thead>
          <tbody>
            {rates.map((r) => (
              <tr key={r.country_code} className="border-t border-[var(--ra-border)] hover:bg-[var(--ra-bg)]" data-testid={`rate-row-${r.country_code}`}>
                <td className="px-5 py-3.5">
                  <div className="flex items-center gap-3"><span className="text-xl">{r.flag}</span><span className="font-medium">{r.country}</span></div>
                </td>
                <td className="px-5 py-3.5 text-[var(--ra-muted)]">{r.currency}</td>
                <td className="px-5 py-3.5 text-right font-heading font-semibold">{r.rate.toLocaleString()}</td>
                <td className="px-5 py-3.5 text-right text-[var(--ra-primary)] font-semibold">{(r.rate * 100).toLocaleString()}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="grid sm:grid-cols-2 gap-4 mt-6 fade-up fade-up-3">
        <div className="ra-card p-5" data-testid="fee-card">
          <div className="flex items-center gap-2 text-[var(--ra-primary)] font-semibold mb-1"><Zap size={16} /> Our fee</div>
          <p className="text-2xl font-heading font-bold">Zero fees</p>
          <p className="text-sm text-[var(--ra-muted)] mt-1">No transfer fees, ever. What you send is what you pay.</p>
        </div>
        <div className="ra-card p-5" data-testid="margin-card">
          <div className="flex items-center gap-2 text-[var(--ra-primary)] font-semibold mb-1"><ShieldCheck size={16} /> Exchange rate</div>
          <p className="text-2xl font-heading font-bold">Great rate</p>
          <p className="text-sm text-[var(--ra-muted)] mt-1">A strong exchange rate on every transfer — and you never pay a fee.</p>
        </div>
      </div>

      <div className="mt-4 text-xs text-[var(--ra-muted)] flex items-center gap-1.5"><TrendingUp size={12} /> Rates are indicative and may shift slightly at the moment of transfer.</div>
      <div className="mt-1 text-[11px] text-[var(--ra-muted)]">Rates By Exchange Rate API</div>
    </div>
  );
};

export default Rates;
